import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import ErrorBoundary from 'app/shared/error/error-boundary';

interface ErrorBoundaryRouteProps extends RouteProps {
  isAuthenticated?: boolean;
}

export const ErrorBoundaryRoute = ({ component: Component, isAuthenticated, ...rest }: ErrorBoundaryRouteProps) => {
  const encloseInErrorBoundary = props => (
    <ErrorBoundary>
      <Component isAuthenticated={isAuthenticated} {...props} />
    </ErrorBoundary>
  );

  if (!Component) throw new Error(`A component needs to be specified for path ${(rest as any).path}`);

  return <Route {...rest} render={encloseInErrorBoundary} />;
};

export default ErrorBoundaryRoute;
